import { HALApiService } from './../../../../services/hal-api.service'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {}
}